// dna_frontend/src/App.js
// (*** ĐÃ CẬP NHẬT: Thêm route Quét Trùng lặp ***)

import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// Import Layout
import Layout from './components/Layout'; 

// Import Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import ChangePassword from './pages/ChangePassword';
import AdminUpload from './pages/AdminUpload';
import XaRaSoat from './pages/XaRaSoat'; 
import TinhThuMau from './pages/TinhThuMau'; 
import LichThuMau from './pages/LichThuMau'; 
import SearchExport from './pages/SearchExport'; 
import BaoCao from './pages/BaoCao'; 
import LietSiManagement from './pages/LietSiManagement'; 
import AdminUploadThuMau from './pages/AdminUploadThuMau';
import ThanNhanManagement from './pages/ThanNhanManagement';
import AdminDuyetXoa from './pages/AdminDuyetXoa';
import AdminUpdateNamSinh from './pages/AdminUpdateNamSinh';
import XaXacMinh from './pages/XaXacMinh';
import AdminXacMinh from './pages/AdminXacMinh';
import AdminCheckDuplicates from './pages/AdminCheckDuplicates'; // (*** MỚI ***)
import XaTraCuu from './pages/XaTraCuu';
import AdminUploadTraCuu from './pages/AdminUploadTraCuu';
import LSDongNoi from './pages/LSDongNoi';

// Middleware bảo vệ Route
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};
const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" />;
  if (user?.role !== 'admin') return <Navigate to="/dashboard" />;
  return <Layout>{children}</Layout>;
};

const XaOrAdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" />;
  if (user?.role !== 'xa' && user?.role !== 'admin') {
      return <Navigate to="/dashboard" />;
  }
  return <Layout>{children}</Layout>;
};

const TinhOrAdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" />;
  if (user?.role !== 'admin' && user?.role !== 'tinh') {
    return <Navigate to="/dashboard" />;
  }
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {/* Chung (Đã đăng nhập) */}
        <Route 
          path="/dashboard" 
          element={<PrivateRoute><Dashboard /></PrivateRoute>} 
        />
        <Route 
          path="/change-password" 
          element={<PrivateRoute><ChangePassword /></PrivateRoute>} 
        />
        <Route 
          path="/lich-thu-mau" 
          element={<PrivateRoute><LichThuMau /></PrivateRoute>} 
        />
         <Route 
          path="/search-export" 
          element={<PrivateRoute><SearchExport /></PrivateRoute>} 
        />

        {/* --- NHÓM ADMIN --- */}
        <Route 
          path="/admin/users" 
          element={<AdminRoute><UserManagement /></AdminRoute>} 
        />
        <Route 
          path="/admin/upload" 
          element={<AdminRoute><AdminUpload /></AdminRoute>} 
        />
        <Route 
          path="/admin/upload-thu-mau" 
          element={<AdminRoute><AdminUploadThuMau /></AdminRoute>} 
        />
        <Route 
          path="/bao-cao" 
          element={<AdminRoute><BaoCao /></AdminRoute>} 
        />
        <Route 
          path="/admin/than-nhan" 
          element={<AdminRoute><ThanNhanManagement /></AdminRoute>} 
        />
        <Route 
          path="/admin/duyet-xoa" 
          element={<AdminRoute><AdminDuyetXoa /></AdminRoute>} 
        />
        <Route 
          path="/admin/update-nam-sinh" 
          element={<AdminRoute><AdminUpdateNamSinh /></AdminRoute>} 
        />
        <Route 
          path="/admin/xac-minh" 
          element={<AdminRoute><AdminXacMinh /></AdminRoute>} 
        />
        {/* (*** MỚI ***) Route Quét Trùng Lặp */}
        <Route 
          path="/admin/check-duplicates" 
          element={<XaOrAdminRoute><AdminCheckDuplicates /></XaOrAdminRoute>} 
        />
        
        {/* --- NHÓM XÃ & ADMIN --- */}
        <Route 
          path="/xa/ra-soat" 
          element={<XaOrAdminRoute><XaRaSoat /></XaOrAdminRoute>} 
        />
        <Route 
          path="/xa/xac-minh" 
          element={<XaOrAdminRoute><XaXacMinh /></XaOrAdminRoute>} 
        />
        <Route 
          path="/liet-si-management" 
          element={<XaOrAdminRoute><LietSiManagement /></XaOrAdminRoute>} 
        />
        
        {/* --- NHÓM TỈNH & ADMIN --- */}
        <Route 
          path="/tinh/thu-mau" 
          element={<TinhOrAdminRoute><TinhThuMau /></TinhOrAdminRoute>} 
        />
        
        <Route 
          path="/" 
          element={localStorage.getItem('token') ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} 
        />
        
        <Route path="*" element={<PrivateRoute><h3>404 - Trang không tồn tại</h3></PrivateRoute>} /> 
        <Route path="/tra-cuu-tham-khao" element={<Layout><XaTraCuu /></Layout>} />
        <Route path="/admin/upload-tra-cuu" element={<Layout><AdminUploadTraCuu /></Layout>} />
        <Route path="/ls-dong-noi" element={<Layout><LSDongNoi /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;